// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { atmosphereFragmentDeclaration } from "../Shaders/ShadersInclude/atmosphereFragmentDeclaration";
import { atmosphereUboDeclaration } from "../Shaders/ShadersInclude/atmosphereUboDeclaration";
import { helperFunctions } from "core/Shaders/ShadersInclude/helperFunctions";
import { intersectionFunctions } from "core/Shaders/ShadersInclude/intersectionFunctions";
import { atmosphereFunctions } from "../Shaders/ShadersInclude/atmosphereFunctions";

const name = "transmittancePixelShader";
const shader = `#define RENDER_TRANSMITTANCE
#define EXCLUDE_RAY_MARCHING_FUNCTIONS
precision highp float;
#include<__decl__atmosphereFragment>
#include<helperFunctions>
#include<atmosphereFunctions>
varying vec2 uv;void main() {gl_FragColor=renderTransmittance(uv);}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
const includes = [atmosphereFragmentDeclaration, atmosphereUboDeclaration, helperFunctions, intersectionFunctions, atmosphereFunctions];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStore[inc.name]) {
        ShaderStore.IncludesShadersStore[inc.name] = inc.shader;
    }
}

/** @internal */
export const transmittancePixelShader = { name, shader };
